// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e6-a";
export var fulfillmentFormRail = "_e6-9";
export var headerTitleRow = "_e6-c";
export var orderDetailsWrapper = "_e6-7";
export var orderLinkTrigger = "_e6-2";
export var paymentInformationGrid = "_e6-h";
export var paymentSummaryColumn = "_e6-i";
export var shipmentContainer = "_e6-b";
export var shipmentDetailsMainPane = "_e6-8";
export var shipmentNavigationCard = "_e6-5";
export var shipmentNavigationRail = "_e6-3";
export var shipmentNavigationRailHeader = "_e6-4";
export var shipmentSummaryFact = "_e6-e";
export var shipmentSummaryGrid = "_e6-d";
export var shipmentSummaryMetadataRow = "_e6-f";
export var shipmentSummaryTags = "_e6-g";
export var shipmentWorkspace = "_e6-0";
export var shipmentWorkspaceContent = "_e6-6";
export var shipmentWorkspaceHeader = "_e6-1";